const numberFormatCache: Map<string, Intl.NumberFormat> = new Map<string, Intl.NumberFormat>();

const fallbackTextThresholdPercentage = 9.99;

const useFormattedDiscount = (
  recommendedPrice: number | undefined,
  currentPrice: number | undefined,
  locale: string
): string | null => {
  let formattedDiscount: string | null = null;

  if (typeof recommendedPrice === 'undefined' || typeof currentPrice === 'undefined') {
    return null;
  }

  if (currentPrice < recommendedPrice) {
    const percentage = ((recommendedPrice - currentPrice) / recommendedPrice) * 100;
    if (percentage > fallbackTextThresholdPercentage) {
      let numberFormat = numberFormatCache.get(locale);
      if (numberFormat === undefined) {
        numberFormat = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        numberFormatCache.set(locale, numberFormat);
      }
      formattedDiscount = `${numberFormat.format(percentage)} %`;
    } else {
      formattedDiscount = null;
    }
  }

  return formattedDiscount;
};

export default useFormattedDiscount;
